// CONNECTED TABS
ui.tabs(document.getElementById('connectedTabs'));
// PAGE LEVEL TABS
ui.tabs(document.getElementById('pageTabContainerLevel'));
// CONTAINER LEVEL TABS
ui.tabs(document.getElementById('containerLevelTab'));
// VERTICAL TABS REPSONSIVE ON TABLET
ui.tabs(document.getElementById('verticalTabs480'));
//  VERTICAL TABS REPSONSIVE ON MOBILE
ui.tabs(document.getElementById('verticalTabs320'));
// TABS WITH ANCHORS
ui.tabs(document.getElementById('aTabs'));
// SCROLLABLE, LOTS OF TABS
ui.tabs(document.getElementById('lotsOfTabs'));
// TAB WITH LONG TITLES CAUISNG OVERFLOW
ui.tabs(document.getElementById('tabContainerLevel'));




// WEBPACK FOOTER //
// ./src/components/tabs/tabs.demo.js